export { default } from './es/icons/JpgTwoTone';